var ValidationException = function (key, params) {
  this.key = key;
  this.params = params;
};

export default ValidationException;
